<template>
  <div class="client-item-box new-banner" v-if="items && items.length" :data-trackdata="tData">
    <div class="new-banner-box">
        <div class="images" v-if="swiper">
          <swiper 
            :config="swiper"
            :paginateCls="paginateCls"
            :scrollbarCls="scrollbarCls"
            :showPaginate="showPaginate"
            :showScrollbar="showScrollbar"
          >
            <div 
              class="swiper-slide new-banner-item" 
              :style="{borderRadius: `${radius}`}"
              v-for="(item, index) in items" 
              :key="index"
              :class="videowrap(index)" 
              @click="mediaAction(item, index)"
            >
              <img 
                v-if="item.type === 'image' && (!item.linkCheck || item.linkCheck === 'SINGLE')" 
                :src="ensureImage(item.image.src)" 
              />
              <div class="swiper-hot" v-if="item.type === 'image' && item.linkCheck === 'MULTI'">
                <img :src="ensureImage(item.image.src)" />
                <div class="hot-areas" v-if="item.hotItems && item.hotItems.length">
                  <div class="hot-area" 
                    v-for="(hotItem, hotIndex) in item.hotItems"
                    :key="hotIndex"
                    :style="{'width': `${hotItem.area.w*ratio}px`, 'height': `${hotItem.area.h*ratio}px`, 'left': `${hotItem.area.x*ratio}px`, 'top': `${hotItem.area.y*ratio}px`}"
                    @click="hotAreaAction(hotItem, index)">
                  </div>
                </div>
              </div>
              <beast-video
                v-if="item.type === 'video'"
                :videoId="`newbanner${modIndex}-${index}`"
                :videoIndex="videoIndex"
                :totalVideo="items.length"
                :wrap="videowrap(index)"
                :height="item.heightNum"
                :poster="item.poster"
                :autoplay="item.autoplay"
                :source="item.source"
                :controls="item.controls"
                :videoFormat="item.videoFormat"
                :muted="item.muted"
                :radius="radius"
                :multiVideo="multiVideo"
                :videoPopData="item"
                @video-pop="videoPopAction"
              />
            </div>
          </swiper>
        </div>
    </div>

    <video-pop
      v-if="videoPopFlag"
      :data="videoPopData"
      :radius="radius"
      @close="closeAction"
    />
  </div>
</template>

<script>

import { ensure_protocol } from '@beastshop/url-util'
import { getClientWidth, trackAction } from '../lib/util.js'
import { transformLink, normalSkip, getToMiniLink, getLinkPageData } from '@/link'

import Swiper from '@/swiper/swiper-4.4.6/index.vue'
import beastImage from '@/components/image'
import beastVideo from '@/components/video'
import videoPop from './video-pop.vue'
import { zipImage } from '@/util'

const clientWidth = getClientWidth()
const ratio = clientWidth/375

export default {
  name: 'image-banner',
  // props: ['data'],
  props: ['data', 'memberTags', 'modIndex', 'sdk', 'miniEnv', 'multiVideo', 'isApp', 'pageType'],
  data () {
    return {
      ratio: ratio,
      items: [],
      swiper: null,
      // paginateCls: (!this.data.hideIdentification && this.paginateType==='number')?paginateCls:{},
      paginateCls: {},
      scrollbarCls: {},
      showPaginate: false,
      showScrollbar: false,
      pl: 0,
      pr: 0,
      pt: 0,
      pb: 0,
      radius: 0,
      videoPopData: null,
      videoPopFlag: false,
      videoIndex: 0,
      tData: JSON.stringify(this.data.trackData || {})
    }
  },
  components: {
    Swiper,
    beastImage,
    beastVideo,
    videoPop
  },
  mounted () {
  },
  computed: {
    // styleObj () {
    //   return {
    //     'padding-left': `${ratio*this.pl}px`,
    //     'padding-right': `${ratio*this.pr}px`,
    //     'padding-top': `${ratio*this.pt}px`,
    //     'padding-bottom': `${ratio*this.pb}px`
    //   }
    // }
  },
  created() {
    this.formatData()
  },
  methods: {
    videowrap (index) {
      return `wrap${this.modIndex}-${index}`
    },

    formatData () {
      // const pl = this.data.leftPadding?Number(this.data.leftPadding):0
      // const pr = this.data.rightPadding?Number(this.data.rightPadding):0
      // const pt = this.data.topPadding?Number(this.data.topPadding):0
      // const pb = this.data.bottomPadding?Number(this.data.bottomPadding):0
      // this.pl = pl
      // this.pr = pr
      // this.pt = pt
      // this.pb = pb
      const {
        pl,
        pr
      } = this.data.paddingData
      this.radius = this.data.radius?`${Number(this.data.radius)*ratio}px`:0

      let items = []
      const tags = this.memberTags || []
      if(!tags.length) {//不校验新老客
        items = this.data.items
      } else {
        this.data.items && this.data.items.forEach(item => {
          // if(item.customer === 'ALL' || tags.indexOf(item.customer) !== -1) {
          //   items.push(item)
          // }
          if(item.customer === 'ALL' || tags.indexOf(item.customer) !== -1 || (item.customer === 'DELINEATION' && tags.indexOf(item.customerCode) !== -1)) {
            items.push(item)
          }
        })
      }

      // const widthNum = (375-pl-pr)*ratio
      const widthNum = (375-pl-pr)*ratio
      const newItems = []
      items.forEach((item, index) => {
        const url = item.media.src
        const stuffIndex = url.lastIndexOf('.')
        const stuff = url.substring(stuffIndex).toLowerCase()
        const type = (stuff === '.mp4')?'video':'image'

        let image = {
          type,
          image: item.media,
          toMiniProgram: item.toMiniProgram,
          link: item.link,
          trackTitle: item.trackTitle,
          trackServiceType: item.trackServiceType,
          linkCheck: item.linkCheck || 'SINGLE',
          hotItems: item.hotItems || []
        }
        if(type === 'video') {
          const videoMode = this.data.videoMode
          image['wrapIndex'] = `wrap${this.modIndex}-${index}`
          image['wrapPopIndex'] = `wrap${this.modIndex}-${index}-1`
          const poster = zipImage(item.poster)
          image['poster'] = poster && ensure_protocol(poster.src)
          image['source'] = item.media && ensure_protocol(item.media.src)
          image['heightNum'] = item.poster?((widthNum/item.poster.width)*item.poster.height):((widthNum/item.media.width)*item.media.height)
          // image['height'] = (widthNum/item.poster.width)*item.poster.height//弹框视频
          image['muted'] = (this.data.videoVoice === 'OPEN')?'':'muted',
          image['videoMode'] = videoMode
          image['videoFormat'] = this.data.videoFormat
          image['autoplay'] = (videoMode==='AUTO' || videoMode==='CONTROL')?true:false
          image['controls'] = videoMode==='AUTO'?false:true
        }

        newItems.push(image)
      })

      const that = this
      const swiperOption = {
        paginationClickable: true,
        spaceBetween: 30,
        centeredSlides: true,
        // autoplay: 4000,
        // autoplay: false,
        // autoplayDisableOnInteraction: false,
        autoplay: (this.data.autoPlay==='YES')?{
          delay: this.data.loopTime?Number(this.data.loopTime)*1000:3000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        }:false,
        on:{
          slideChange: function () {
            // alert('改变了，activeIndex为'+this.activeIndex);

            that.videoIndex = this.activeIndex
          },
        }
      }

      const identificationType = this.data.identificationType
      // const identificationType = 'VERTICAL'
      this.showPaginate = (identificationType === 'NONE' || identificationType === 'SCROLLBAR')?false:true
      this.showScrollbar = (identificationType === 'SCROLLBAR')?true:false
      
      if(this.showPaginate) {
        if(identificationType === 'DOT') {//圆点轮播
          this.paginateCls = {'dot-paginate': true}
          swiperOption['pagination'] = {
            el: '.swiper-pagination', 
            type: 'bullets'
          }
        }

        if(identificationType === 'ALIGN') {//短横线轮播
          this.paginateCls = {'align-paginate': true}
          swiperOption['pagination'] = {
            el: '.swiper-pagination', 
            type: 'bullets'
          }
        }

        if(identificationType === 'NUMBER') {//数字轮播
          this.paginateCls = {'number-paginate': true}
          swiperOption['pagination'] = {
            el: '.swiper-pagination', 
            type: 'fraction'
          }
        }

        if(identificationType === 'VERTICAL') {//竖线轮播
          this.paginateCls = {'vertical-paginate': true}
          swiperOption['pagination'] = {
            el: '.swiper-pagination', 
            type: 'bullets'
          }
        }
      }

      if(identificationType === 'SCROLLBAR') {//滚动条轮播
        this.scrollbarCls = {'scrollbar-custom': true}
        swiperOption['scrollbar'] = {
          el: '.swiper-scrollbar'
        }
      }

      this.swiper = swiperOption
      console.log(this.swiper, "swiper")
      console.log(newItems, "newItems")

      this.items = newItems
    },

    ensureImage (src) {
      return ensure_protocol(src)
    },

    mediaAction (item, index) {
      // console.log(item, 'new banner imageAction item')
      // return
      if(this.pageType === 'index' && item.type === 'video') {//首页视频 不允许跳转
        return
      }
      if(this.pageType === 'article' && item.type === 'video' && item.videoMode !== 'AUTO') {//专题页 非背景自动播放视频 不允许跳转
        return
      }

      // if(!item.link.type || item.link.type === 'none') {
      //   return
      // }

      const trackData = this.data.trackData
      trackData.module_number = index-0+1
      trackData.operation_name = item.trackTitle
      trackData.operation_type = item.trackServiceType || ''

      this.skipAction({
        link: item.link,
        toMiniProgram: item.toMiniProgram,
        trackData
      })
    },

    hotAreaAction (hotItem, index) {
      const trackData = this.data.trackData
      trackData.module_number = index-0+1
      trackData.operation_name = hotItem.trackTitle || ''
      trackData.operation_type = hotItem.trackServiceType || ''
      
      this.skipAction({
        link: hotItem.link,
        toMiniProgram: hotItem.toMiniProgram,
        trackData
      })

      // this.skipLink({
      //   link: hotItem.link,
      //   title: '',
      //   trackData,
      //   toMiniProgram: hotItem.toMiniProgram
      // })
    },

    skipAction ({link, toMiniProgram, trackData}) {
      if(!link.type || link.type === 'none') {
        return
      }

      let myLink = ''
      let toMiniFlag = false
      if(this.isApp && toMiniProgram) {//app环境 且 在app打开小程序页面
        myLink = getToMiniLink({
                link
              })
      }
      if(myLink) {
        toMiniFlag = true
      }
      if(!myLink) {
        myLink = transformLink({
                link,
                isMini: this.miniEnv
              })
      }

      trackAction({
        trackData,
        pageObj: getLinkPageData({
          link
        })
      })

      normalSkip({
        link: myLink,
        isMini: this.miniEnv,
        toMiniProgram: toMiniFlag
      })
    },

    videoPopAction (data) {
      this.videoPopData = data
      this.videoPopFlag = true
    },

    closeAction () {
      this.videoPopFlag = false
    },
  }
}
</script>



// WEBPACK FOOTER //
// new-banner.vue?5e9f2136